import dynamic from "next/dynamic";

export default dynamic(()=> import("./LeadForm"), {
    ssr: false,
})